module.exports = __webpack_public_path__ + "img/8.ad3ae589.png";